var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 10V11.5C10.375 11.8978 10.2104 12.2794 9.91735 12.5607C9.62433 12.842 9.2269 13 8.8125 13H2.5625C2.1481 13 1.75067 12.842 1.45765 12.5607C1.16462 12.2794 1 11.8978 1 11.5V2.5C1 2.10218 1.16462 1.72064 1.45765 1.43934C1.75067 1.15804 2.1481 1 2.5625 1H8.5C9.36289 1 10.375 1.67163 10.375 2.5V4",
    stroke: "#FF6666",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 10L16 7L12.875 4",
    stroke: "#FF6666",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 7H15.375",
    stroke: "#FF6666",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.597ab24e4c6512bcfd8774177c36e1db.svg";
export { ForwardRef as ReactComponent };